import { type Color } from 'antd/es/color-picker'

export const ensureHexString = (
  color: Color | string | undefined
): string | undefined => {
  if (!color) return
  if (typeof color === 'string') return color
  return color.toHexString()
}
